import React from "react";
import Modal from "../../../../components/common/Modal";

interface TocFormExampleModalProps {
  /** Controls whether the modal is visible */
  isOpen: boolean;
  /** Callback fired when the user closes the modal */
  onClose: () => void;
}

/**
 * TocFormExampleModal - Modal for displaying TOC form example images.
 *
 * Shows a sequence of example images for the Test of Change form,
 * opened when the user clicks "here for an example of a completed form"
 * in the Test Of Change Page Help popup.
 *
 * @param isOpen - Whether the modal is currently visible.
 * @param onClose - Callback to close the modal.
 * @returns The TOC form example modal component.
 */
const TocFormExampleModal: React.FC<TocFormExampleModalProps> = ({
  isOpen,
  onClose,
}) => (
  <Modal
    isOpen={isOpen}
    title="TOC Form Questions & Answers"
    onClose={onClose}
    onSecondary={onClose}
    clearBtn="Close"
    contentClassName="mb-4!"
  >
    <div className="flex flex-col gap-6 py-2">
      <img
        src="/assets/images/toc-details.png"
        alt="TOC details form example"
        className="w-full rounded"
      />
      <img
        src="/assets/images/toc-add-new-test.png"
        alt="Add new TOC test form example"
        className="w-full rounded"
      />
    </div>
  </Modal>
);

export default TocFormExampleModal;
